module.exports = __webpack_public_path__ + "media/images/lb/497-4e8ebd674d58bbe9321171c6cb587c60.svg";